import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import MenuProductCardUI from './MenuProductCardUI';

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

const MenuProductCardContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuProductCardUI);

export default MenuProductCardContainer;
